// pages/Home.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../app-config";
import BannerCarousel from "../components/banner-carousel";
import SidebarHeader from "../components/SidebarHeader";
import BottomNav from "../components/bottom-menu";
import toast, { Toaster } from 'react-hot-toast';
import { apiCall } from "../utils/api";
import Bmnemonic_PNG from "../assets/image/Bmnemonic_PNG.png";
import APDCL_PNG from "../assets/image/apdcl_icon.png";

// Import React Icons
import {
    HiOutlineDeviceMobile,
    HiOutlineDesktopComputer,
    HiOutlineLightBulb,
    HiOutlineCreditCard,
    HiOutlineGift,
    HiOutlinePhone,
    HiOutlineWifi,
    HiOutlineHome,
    HiOutlineUserGroup,
    HiOutlineAcademicCap,
    HiOutlineShieldCheck,
    HiOutlineHeart,
    HiOutlineCurrencyRupee,
    HiOutlineOfficeBuilding,
    HiOutlineDroplet,
    HiOutlineReceiptRefund,
    HiOutlineCollection,
    HiOutlineCash,
    HiOutlineSupport,
    HiOutlineWallet,
    HiOutlinePlusCircle
} from 'react-icons/hi';

import {
    FaMobileAlt,
    FaTv,
    FaBolt,
    FaTag,
    FaPhoneAlt,
    FaGift,
    FaGasPump,
    FaGlobe,
    FaRegCreditCard,
    FaGraduationCap,
    FaShieldAlt,
    FaHospital,
    FaHandHoldingUsd,
    FaHome,
    FaBuilding,
    FaWater,
    FaHandsHelping,
    FaWifi,
    FaRegCalendarAlt
} from 'react-icons/fa';

import {
    MdOutlineAccountBalanceWallet,
    MdAddCircleOutline,
    MdSupportAgent,
    MdOutlinePhone,
    MdOutlineTv,
    MdOutlineBolt,
    MdOutlineReceiptLong,
    MdOutlineCardGiftcard,
    MdOutlineWifi,
    MdOutlineHome,
    MdOutlinePeople,
    MdOutlineSchool,
    MdOutlineShield,
    MdOutlineLocalHospital,
    MdOutlineAttachMoney,
    MdOutlineBusinessCenter,
    MdOutlineWater,
    MdOutlineVolunteerActivism,
    MdOutlineDevices
} from 'react-icons/md';

const COLORS = APP_CONFIG.colors;

const serviceIcons = {
    phone: (color) => <FaMobileAlt size={26} color={color} />,
    dth: (color) => <FaTv size={26} color={color} />,
    electricity: (color) => <FaBolt size={26} color={color} />,
    fastag: (color) => <FaTag size={26} color={color} />,
    postpaid: (color) => <FaPhoneAlt size={26} color={color} />,
    gift: (color) => <FaGift size={26} color={color} />,
    gas: (color) => <FaGasPump size={26} color={color} />,
    broadband: (color) => <FaGlobe size={26} color={color} />,
    cable: (color) => <FaTv size={26} color={color} />,
    creditcard: (color) => <FaRegCreditCard size={26} color={color} />,
    education: (color) => <FaGraduationCap size={26} color={color} />,
    insurance: (color) => <FaShieldAlt size={26} color={color} />,
    hospital: (color) => <FaHospital size={26} color={color} />,
    loan: (color) => <FaHandHoldingUsd size={26} color={color} />,
    housing: (color) => <FaHome size={26} color={color} />,
    municipal: (color) => <FaBuilding size={26} color={color} />,
    water: (color) => <FaWater size={26} color={color} />,
    donation: (color) => <FaHandsHelping size={26} color={color} />,
    prepaid: (color) => <FaMobileAlt size={26} color={color} />,
    subscription: (color) => <FaRegCalendarAlt size={26} color={color} />
};

const services = [
    { label: "Mobile", category: "", icon: "phone", tab: "mobile" },
    { label: "DTH", category: "", icon: "dth", tab: "dth" },
    { label: "APDCL", category: "APDCL", icon: "png", tab: "bill" },
    { label: "FASTag", category: "Fastag", icon: "fastag", tab: "bill" },
    { label: "Postpaid", category: "Postpaid", icon: "postpaid", tab: "bill" },
    { label: "Redeem", category: "", icon: "gift", tab: "redeem" },
    { label: "Billpay", category: "", icon: "png", tab: "bill" },
];

const top_services = [
    { label: "Mobile", category: "", icon: "phone", tab: "mobile" },
    { label: "DTH", category: "", icon: "dth", tab: "dth" },
    { label: "Electricity", category: "Electricity", icon: "electricity", tab: "bill" },
    { label: "FASTag", category: "Fastag", icon: "fastag", tab: "bill" }
];

// Additional services for desktop only
const desktopServices = [
    { label: "Electricity", category: "Electricity", icon: "electricity", tab: "bill" },
    { label: "Fastag", category: "Fastag", icon: "fastag", tab: "bill" },
    { label: "Gas", category: "Gas", icon: "gas", tab: "bill" },
    { label: "Broadband", category: "Broadband", icon: "broadband", tab: "bill" },
    { label: "Cable TV", category: "Cable", icon: "cable", tab: "bill" },
    { label: "Clubs", category: "Clubs", icon: "housing", tab: "bill" },
    { label: "Credit Card", category: "Credit Card", icon: "creditcard", tab: "bill" },
    { label: "Education Fees", category: "Education", icon: "education", tab: "bill" },
    { label: "Health Insurance", category: "Insurance", icon: "insurance", tab: "bill" },
    { label: "Hospital", category: "Hospital", icon: "hospital", tab: "bill" },
    { label: "Hospital & Pathology", category: "Hospital", icon: "hospital", tab: "bill" },
    { label: "Housing Society", category: "Housing", icon: "housing", tab: "bill" },
    { label: "Insurance", category: "Insurance", icon: "insurance", tab: "bill" },
    { label: "Landline", category: "Landline", icon: "phone", tab: "bill" },
    { label: "Life Insurance", category: "Insurance", icon: "insurance", tab: "bill" },
    { label: "Loan Repayment", category: "Loan", icon: "loan", tab: "bill" },
    { label: "LPG Gas", category: "Gas", icon: "gas", tab: "bill" },
    { label: "Mobile Postpaid", category: "Postpaid", icon: "postpaid", tab: "bill" },
    { label: "Municipal Services", category: "Municipal", icon: "municipal", tab: "bill" },
    { label: "Municipal Taxes", category: "Municipal", icon: "municipal", tab: "bill" },
    { label: "Postpaid", category: "Postpaid", icon: "postpaid", tab: "bill" },
    { label: "Recurring Deposit", category: "Deposit", icon: "loan", tab: "bill" },
    { label: "Subscription", category: "Subscription", icon: "subscription", tab: "bill" },
    { label: "Water", category: "Water", icon: "water", tab: "bill" },
    { label: "Donation", category: "Donation", icon: "donation", tab: "bill" },
    { label: "Prepaid Meter", category: "Prepaid", icon: "prepaid", tab: "bill" },
];

// Banner caching helpers
const BANNER_CACHE_KEY = 'banner_data';
const BANNER_TIMESTAMP_KEY = 'banner_timestamp';
const CACHE_DURATION = 30 * 60 * 1000;

const getCachedBanner = () => {
    try {
        const cachedData = localStorage.getItem(BANNER_CACHE_KEY);
        const timestamp = localStorage.getItem(BANNER_TIMESTAMP_KEY);
        if (cachedData && timestamp) {
            const now = Date.now();
            const cacheAge = now - parseInt(timestamp);
            if (cacheAge < CACHE_DURATION) {
                return JSON.parse(cachedData);
            }
        }
        return null;
    } catch (error) {
        console.error('Error reading banner cache:', error);
        return null;
    }
};

const setCachedBanner = (bannerData) => {
    try {
        localStorage.setItem(BANNER_CACHE_KEY, JSON.stringify(bannerData));
        localStorage.setItem(BANNER_TIMESTAMP_KEY, Date.now().toString());
    } catch (error) {
        console.error('Error saving banner cache:', error);
    }
};

function Home() {
    const navigate = useNavigate();
    const [hoveredCard, setHoveredCard] = useState(null);
    const [balance, setBalance] = useState(localStorage.getItem("balance") || "0.00");
    const [bannerData, setBannerData] = useState(null);

    useEffect(() => {
        const getDeviceInfo = () => {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: "GET_DEVICE_INFO" })
                );
            }
        };
        getDeviceInfo();
    }, []);

    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const result = await apiCall("balance", {}, true);
                if (result.status === true) {
                    setBalance(result.data.balance);
                    localStorage.setItem("balance", result.data.balance);
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            }
        };

        const fetchBanner = async () => {
            const cachedBanner = getCachedBanner();
            if (cachedBanner) {
                console.log('Using cached banner data');
                setBannerData(cachedBanner);
                return;
            }
            try {
                const result = await apiCall("banner", {}, true);
                if (result.status === true && result.banner) {
                    setBannerData(result.banner);
                    setCachedBanner(result.banner);
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            }
        };

        fetchBalance();
        fetchBanner();
    }, []);

    const renderIcon = (service) => {
        if (service.icon === 'png') {
            if (service.category === 'APDCL') {
                return (
                    <img
                        src={APDCL_PNG}
                        alt="Billpay"
                        style={{
                            width: 26,
                            height: 26,
                            objectFit: 'contain'
                        }}
                    />
                );
            }
            return (
                <img
                    src={Bmnemonic_PNG}
                    alt="Billpay"
                    style={{
                        width: 26,
                        height: 26,
                        objectFit: 'contain'
                    }}
                />
            );
        }
        return serviceIcons[service.icon](COLORS.primaryColor);
    };

    // Service card component to avoid duplication
    const ServiceCard = ({ service, index, isTopService, isDesktop = false }) => {
        const cardIndex = isTopService ? index : (isDesktop ? index + 100 : index + 10);
        const isColored = isTopService;

        return (
            <div
                onClick={() => {
                    console.log(service.category);
                    if (service.category === 'APDCL') {
                        navigate('/additional/apdcl');
                    } else {
                        navigate('/services', {
                            state: {
                                category: service.category,
                                tab: service.tab,
                            },
                        });
                    }
                }}
                className="flex flex-col items-center gap-2 cursor-pointer w-full"
            >
                <div
                    onMouseEnter={() => setHoveredCard(cardIndex)}
                    onMouseLeave={() => setHoveredCard(null)}
                    className="w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-200"
                    style={{
                        background: isColored
                            ? COLORS.primaryColor
                            : (hoveredCard === cardIndex ? `${COLORS.primaryColor}20` : COLORS.surfaceColor),
                        border: `1px solid ${isColored
                            ? 'transparent'
                            : (hoveredCard === cardIndex ? COLORS.primaryColor : COLORS.borderColor)}`,
                        boxShadow: hoveredCard === cardIndex ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
                        transform: hoveredCard === cardIndex ? "scale(1.05)" : "scale(1)",
                    }}
                >
                    <div style={isColored ? { filter: "brightness(0) invert(1)" } : {}}>
                        {renderIcon(service)}
                    </div>
                </div>
                <span
                    className="text-xs font-medium text-center"
                    style={{ color: COLORS.textSecondary }}
                >
                    {service.label}
                </span>
            </div>
        );
    };

    // Left column content - Services (Desktop)
    const ServicesColumn = () => (
        <div className="space-y-4">
            {/* Top Services */}
            <div
                className="rounded-2xl p-4"
                style={{
                    background: COLORS.bgColor,
                    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                    border: `1px solid ${COLORS.borderColor}`,
                }}
            >
                <div className="grid grid-cols-4 gap-4 justify-items-center">
                    {top_services.map((service, index) => (
                        <ServiceCard
                            key={`top-${index}`}
                            service={service}
                            index={index}
                            isTopService={true}
                        />
                    ))}
                </div>
            </div>

            {/* All Services */}
            <div
                className="rounded-2xl p-4"
                style={{
                    background: COLORS.bgColor,
                    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                    border: `1px solid ${COLORS.borderColor}`,
                }}
            >
                <div className="grid grid-cols-4 gap-4 justify-items-center">
                    {services.map((service, index) => (
                        <ServiceCard
                            key={`all-${index}`}
                            service={service}
                            index={index}
                            isTopService={false}
                        />
                    ))}
                </div>
            </div>
        </div>
    );

    // Right column content - Banner, Balance, Support
    const RightColumn = () => (
        <div className="space-y-4">
            {/* Banner Carousel */}
            <BannerCarousel bannerData={bannerData} />

            {/* Wallet Card */}
            <div
                className="rounded-2xl flex items-center justify-between p-4"
                style={{
                    background: COLORS.bgColor,
                    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                    border: `1px solid ${COLORS.borderColor}`,
                }}
            >
                <div className="flex items-center gap-3">
                    <div className="rounded-full p-2.5 flex items-center justify-center" style={{ background: `${COLORS.primaryColor}15` }}>
                        <MdOutlineAccountBalanceWallet size={20} color={COLORS.primaryColor} />
                    </div>
                    <div>
                        <div className="text-xs font-medium tracking-wider" style={{ color: COLORS.textSecondary }}>
                            Wallet Balance
                        </div>
                        <div className="text-lg font-bold" style={{ color: COLORS.textPrimary }}>
                            ₹{balance}
                        </div>
                    </div>
                </div>

                <button
                    onClick={() => navigate("/add-money")}
                    className="px-5 py-2 text-sm font-semibold rounded-full transition-all duration-200 hover:scale-105 active:scale-95"
                    style={{
                        background: COLORS.primaryColor,
                        color: COLORS.textOnPrimary,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                >
                    + Add Money
                </button>
            </div>

            {/* Support Center */}
            <div
                onClick={() => navigate("/support-center")}
                className="relative rounded-2xl p-4 flex items-center cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-98"
                style={{
                    background: COLORS.surfaceColor,
                    border: `1px solid ${COLORS.borderColor}`,
                }}
            >
                <div className="flex items-center gap-3.5">
                    <div
                        className="w-12 h-12 rounded-xl flex items-center justify-center"
                        style={{ background: `${COLORS.primaryColor}15` }}
                    >
                        <MdSupportAgent size={22} color={COLORS.primaryColor} />
                    </div>
                    <div>
                        <div className="text-sm font-bold" style={{ color: COLORS.textPrimary }}>
                            Need Help?
                        </div>
                        <div className="text-xs" style={{ color: COLORS.textSecondary }}>
                            Chat with our support team
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <SidebarHeader>
            <div className="max-w-7xl mx-auto mb-16">
                {/* Desktop Layout */}
                <div className="hidden lg:block">
                    {/* Top section: Services (2/3) + Right Column (1/3) */}
                    <div className="grid grid-cols-3 gap-6">
                        {/* Left Column - 2/3 width */}
                        <div className="lg:col-span-2">
                            <h3
                                className="text-sm font-semibold mb-3 px-1"
                                style={{ color: COLORS.textPrimary }}
                            >
                                Pupular Services
                            </h3>
                            <ServicesColumn />
                        </div>

                        {/* Right Column - 1/3 width */}
                        <div className="lg:col-span-1">
                            <RightColumn />
                        </div>
                    </div>

                    {/* More Services - Full Width with 8 items per row - Same style as regular services */}
                    <div className="mt-6">
                        <div
                            className="rounded-2xl p-4"
                            style={{
                                background: COLORS.bgColor,
                                boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                                border: `1px solid ${COLORS.borderColor}`,
                            }}
                        >
                            <h3
                                className="text-sm font-semibold mb-3 px-1"
                                style={{ color: COLORS.textPrimary }}
                            >
                                More Services
                            </h3>
                            <div className="grid grid-cols-8 gap-4 justify-items-center">
                                {desktopServices.map((service, index) => (
                                    <div
                                        key={`desktop-${index}`}
                                        onClick={() => {
                                            console.log(service.category);
                                            if (service.category === 'APDCL') {
                                                navigate('/additional/apdcl');
                                            } else {
                                                navigate('/services', {
                                                    state: {
                                                        category: service.category,
                                                        tab: service.tab,
                                                    },
                                                });
                                            }
                                        }}
                                        className="flex flex-col items-center gap-2 cursor-pointer w-full"
                                    >
                                        <div
                                            onMouseEnter={() => setHoveredCard(index + 200)}
                                            onMouseLeave={() => setHoveredCard(null)}
                                            className="w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-200"
                                            style={{
                                                background: hoveredCard === index + 200 ? `${COLORS.primaryColor}20` : COLORS.surfaceColor,
                                                border: `1px solid ${hoveredCard === index + 200 ? COLORS.primaryColor : COLORS.borderColor}`,
                                                boxShadow: hoveredCard === index + 200 ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
                                                transform: hoveredCard === index + 200 ? "scale(1.05)" : "scale(1)",
                                            }}
                                        >
                                            {renderIcon(service)}
                                        </div>
                                        <span
                                            className="text-xs font-medium text-center"
                                            style={{ color: COLORS.textSecondary }}
                                        >
                                            {service.label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Layout - Single Column */}
                <div className="lg:hidden">
                    {/* Banner Carousel */}
                    <BannerCarousel bannerData={bannerData} />

                    {/* Wallet Card */}
                    <div
                        className="mt-4 rounded-2xl flex items-center justify-between p-4"
                        style={{
                            background: COLORS.bgColor,
                            boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                            border: `1px solid ${COLORS.borderColor}`,
                        }}
                    >
                        <div className="flex items-center gap-3">
                            <div className="rounded-full p-2.5 flex items-center justify-center" style={{ background: `${COLORS.primaryColor}15` }}>
                                <MdOutlineAccountBalanceWallet size={20} color={COLORS.primaryColor} />
                            </div>
                            <div>
                                <div className="text-xs font-medium tracking-wider" style={{ color: COLORS.textSecondary }}>
                                    Wallet Balance
                                </div>
                                <div className="text-lg font-bold" style={{ color: COLORS.textPrimary }}>
                                    ₹{balance}
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => navigate("/add-money")}
                            className="px-5 py-2 text-sm font-semibold rounded-full transition-all duration-200 hover:scale-105 active:scale-95"
                            style={{
                                background: COLORS.primaryColor,
                                color: COLORS.textOnPrimary,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            }}
                        >
                            + Add Money
                        </button>
                    </div>

                    {/* Top Services */}
                    <div
                        className="rounded-2xl p-4 mt-4"
                        style={{
                            background: COLORS.bgColor,
                            boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                            border: `1px solid ${COLORS.borderColor}`,
                        }}
                    >
                        <div className="grid grid-cols-4 gap-4 justify-items-center">
                            {top_services.map((service, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        console.log(service.category);
                                        if (service.category === 'APDCL') {
                                            navigate('/additional/apdcl');
                                        } else {
                                            navigate('/services', {
                                                state: {
                                                    category: service.category,
                                                    tab: service.tab,
                                                },
                                            });
                                        }
                                    }}
                                    className="flex flex-col items-center gap-2 cursor-pointer w-full"
                                >
                                    <div
                                        onMouseEnter={() => setHoveredCard(index)}
                                        onMouseLeave={() => setHoveredCard(null)}
                                        className="w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-200"
                                        style={{
                                            background: COLORS.primaryColor,
                                            border: `1px solid ${hoveredCard === index ? COLORS.primaryLight : 'transparent'}`,
                                            boxShadow: hoveredCard === index ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
                                            transform: hoveredCard === index ? "scale(1.05)" : "scale(1)",
                                        }}
                                    >
                                        <div style={{ filter: "brightness(0) invert(1)" }}>
                                            {renderIcon(service)}
                                        </div>
                                    </div>
                                    <span
                                        className="text-xs font-medium text-center"
                                        style={{ color: COLORS.textSecondary }}
                                    >
                                        {service.label}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* All Services */}
                    <div
                        className="rounded-2xl p-4 mt-4"
                        style={{
                            background: COLORS.bgColor,
                            boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                            border: `1px solid ${COLORS.borderColor}`,
                        }}
                    >
                        <div className="grid grid-cols-4 gap-4 justify-items-center">
                            {services.map((service, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        console.log(service.category);
                                        if (service.category === 'APDCL') {
                                            navigate('/additional/apdcl');
                                        } else {
                                            navigate('/services', {
                                                state: {
                                                    category: service.category,
                                                    tab: service.tab,
                                                },
                                            });
                                        }
                                    }}
                                    className="flex flex-col items-center gap-2 cursor-pointer w-full"
                                >
                                    <div
                                        onMouseEnter={() => setHoveredCard(index + 10)}
                                        onMouseLeave={() => setHoveredCard(null)}
                                        className="w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-200"
                                        style={{
                                            background: hoveredCard === index + 10 ? `${COLORS.primaryColor}20` : COLORS.surfaceColor,
                                            border: `1px solid ${hoveredCard === index + 10 ? COLORS.primaryColor : COLORS.borderColor}`,
                                            boxShadow: hoveredCard === index + 10 ? "0 4px 12px rgba(0,0,0,0.1)" : "none",
                                            transform: hoveredCard === index + 10 ? "scale(1.05)" : "scale(1)",
                                        }}
                                    >
                                        {renderIcon(service)}
                                    </div>
                                    <span
                                        className="text-xs font-medium text-center"
                                        style={{ color: COLORS.textSecondary }}
                                    >
                                        {service.label}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Support Center */}
                    <div
                        onClick={() => navigate("/support-center")}
                        className="relative rounded-2xl p-4 mt-4 flex items-center cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-98 mb-6 overflow-hidden"
                        style={{
                            background: COLORS.surfaceColor,
                            border: `1px solid ${COLORS.borderColor}`,
                        }}
                    >
                        <div
                            className="absolute top-0 right-0 text-xs font-extrabold text-white uppercase tracking-wider px-3 py-1"
                            style={{
                                background: COLORS.primaryColor,
                                borderBottomLeftRadius: "12px",
                                borderTopRightRadius: "12px",
                            }}
                        >
                            Support
                        </div>
                        <div className="flex items-center gap-3.5">
                            <div
                                className="w-12 h-12 rounded-xl flex items-center justify-center"
                                style={{ background: `${COLORS.primaryColor}15` }}
                            >
                                <MdSupportAgent size={22} color={COLORS.primaryColor} />
                            </div>
                            <div>
                                <div className="text-sm font-bold" style={{ color: COLORS.textPrimary }}>
                                    Need Help?
                                </div>
                                <div className="text-xs" style={{ color: COLORS.textSecondary }}>
                                    Chat with our support team
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toaster />

            {/* Bottom Navigation - Hidden on desktop (lg and above) */}
            <div className="lg:hidden">
                <BottomNav />
            </div>

            <style>
                {`
                .active\\:scale-98:active {
                    transform: scale(0.98);
                }
                .active\\:scale-95:active {
                    transform: scale(0.95);
                }
                `}
            </style>
        </SidebarHeader>
    );
}

export default Home;